export default 'marketingChangelogPage';
